"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DownloadSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28 22a2 2 0 00-2 2v2H6v-2a2 2 0 00-4 0v3.5A2.5 2.5 0 004.5 30h23a2.5 2.5 0 002.5-2.5V24a2 2 0 00-2-2z"/><path d="M13.83 22.05a3 3 0 004.34 0l5.29-5.69a2 2 0 10-2.92-2.72L18 16.36V4a2 2 0 00-4 0v12.36l-2.54-2.72a2 2 0 00-2.92 2.72z"/>';
var DownloadSVG = function DownloadSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.DownloadSVG = DownloadSVG;
DownloadSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DownloadSVG);
exports.default = _default;